import { computed, defineComponent, onMounted, onUnmounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { HolidayAction, HolidayGetter } from '@/store/holiday/holiday.module';
import { Holiday } from '@/store/holiday/holiday.model';
import { useDateFormat } from '@/composables/dateFormat';
import { Popover } from 'bootstrap';
import LoadingComponent from '@/components/loading/Loading.vue';

export default defineComponent({
  name: 'HolidayTableComponent',
  components: {
    LoadingComponent
  },
  props: {
    year: {
      type: Number
    }
  },
  emits: [
    'edit'
  ],
  setup: (props, context) => {
    const store = useStore();
    const holidays = computed<Holiday[]>(() => store.getters[HolidayGetter.BY_YEAR](props.year));
    const isLoading = computed(() => store.getters[HolidayGetter.STATUS] === 'init' || store.getters[HolidayGetter.STATUS] === 'loading');
    const datatable = ref<HTMLTableElement>();
    const dtInstance = ref();
    const dateFormat = useDateFormat();
    const popoverList = ref<Popover[]>([]);

    onMounted(() => {
      store.dispatch(HolidayAction.FETCH)
        .then(() => initialPopover())
        .then(() => initialDataTable());
    });

    onUnmounted(() => {
      dtInstance.value?.destroy();
    });

    watch(() => (holidays.value), () => {
      updateDataTable();
    });

    const editClick = (id: number) => {
      context.emit('edit', id);
    };

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDate(date, 'long');

    const updateDataTable = () => {
      Promise.resolve(dtInstance.value?.destroy())
        .then(() => initialPopover())
        .then(() => initialDataTable());
    };

    const initialDataTable = () => {
      const dt = datatable.value as HTMLTableElement;
      if (!$.fn.dataTable.isDataTable(dt)) {
        dtInstance.value = $(dt).DataTable({
          language: {
            emptyTable: 'ไม่พบข้อมูล',
            info: 'แสดง _START_ ถึง _END_ จากจำนวนทั้งหมด _TOTAL_',
            infoEmpty: 'แสดง 0 ถึง 0 จากจำนวนทั้งหมด 0',
            infoFiltered: '(ค้นหาจากจำนวนทั้งหมด _MAX_)',
            lengthMenu: 'แสดงข้อมูล _MENU_',
            paginate: {
              next: 'ถัดไป',
              previous: 'ก่อนหน้า',
              first: 'First',
              last: 'Last'
            },
            search: 'ค้นหา:',
            zeroRecords: 'ไม่พบข้อมูลที่ค้นหา',
          }
        });
      }
    };
    const initialPopover = () => {
      const popoverTriggerList = computed<HTMLElement[]>(() => [].slice.call(document.querySelectorAll('[data-bs-toggle="popover-holiday"]')) as HTMLElement[]);
      popoverList.value.map(element => element.hide());
      popoverList.value = popoverTriggerList.value?.map(element => new Popover(element, { trigger: 'hover', placement: 'left' }));
    };

    return {
      holidays,
      datatable,
      isLoading,
      editClick,
      thaiDate,
    };
  }
});
